export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14859.d30dd75d.jpg";